import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06233730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "vertical-medium-dialog" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "请点击获取验证码，并输入获取到的验证码", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验证码：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headbar = _resolveComponent("headbar")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_app_main = _resolveComponent("app-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_headbar, {
      onSetShrinState: _ctx.setShrinState,
      ref: "headerView"
    }, null, 8, ["onSetShrinState"]),
    _createVNode(_component_sidebar, {
      collapse: _ctx.collapse,
      class: "sidebar-container",
      ref: "sidebarView"
    }, null, 8, ["collapse"]),
    _createVNode(_component_app_main, {
      collapse: _ctx.collapse,
      ref: "mainView"
    }, null, 8, ["collapse"]),
    _createVNode(_component_mas_modal, {
      visible: _ctx.verticalMediumDialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.verticalMediumDialog) = $event)),
      width: "550px",
      title: _ctx.verticalMediumObj.name,
      customClass: "hbb-dialog-modal",
      closeIcon: "",
      closeOnClickModal: false,
      onConfirm: _ctx.verticalMediumConfirm
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, "手机号：" + _toDisplayString(_ctx.verticalMediumObj.mobile), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.getVerticalCode
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(!_ctx.sendVerticalCode ? "获取验证码" : "重新获取验证码 ") + _toDisplayString(_ctx.sendVerticalCode ? _ctx.getVerticalNumber : ""), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", null, [
            _hoisted_4,
            _createVNode(_component_el_input, {
              type: "text",
              modelValue: _ctx.verticalMediumCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verticalMediumCode) = $event)),
              maxlength: 8,
              placeholder: "请输入验证码"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "onConfirm"])
  ]))
}